"use strict";
/**
 * Temporarily moving translationKey enum from apps/header-bff/src/app/translation to here to use it in header-ui
 * until we come up a good way to differentiate between links in header-ui (we want to pin point help center link to trigger
 * its onSupportClick handler) check packages/header-ui/src/lib/Header/Account and packages/header-ui/src/lib/Header/MainMenu
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslationKey = void 0;
var TranslationKey;
(function (TranslationKey) {
    TranslationKey["SEARCHBAR_CATEGORIES"] = "SEARCHBAR_CATEGORIES";
    TranslationKey["SEARCHBAR_RESULTS_QTY"] = "SEARCHBAR_RESULTS_QTY";
    TranslationKey["SEARCHBAR_PRODUCTS_SECTION_LABEL"] = "SEARCHBAR_PRODUCTS_SECTION_LABEL";
    TranslationKey["SEARCHBAR_NO_RESULTS_TEXT"] = "SEARCHBAR_NO_RESULTS_TEXT";
    TranslationKey["SEARCHBAR_BUTTON_VIEW_RESULTS_V2"] = "SEARCHBAR_BUTTON_VIEW_RESULTS_V2";
    TranslationKey["SEARCHBAR_POPULAR_SEARCHES"] = "SEARCHBAR_POPULAR_SEARCHES";
    TranslationKey["SEARCHBAR_POPULAR_CATEGORIES"] = "SEARCHBAR_POPULAR_CATEGORIES";
    TranslationKey["SEARCHBAR_RECENT_SEARCH_RESULTS"] = "SEARCHBAR_RECENT_SEARCH_RESULTS";
    TranslationKey["SEARCH_CATEGORIES_SHOW_ALL_LABEL"] = "SEARCH_CATEGORIES_SHOW_ALL_LABEL";
    TranslationKey["CATEGORY_MENU_VIEW_ALL"] = "CATEGORY_MENU_VIEW_ALL";
    TranslationKey["CATEGORIES_BUTTON"] = "CATEGORIES_BUTTON";
    TranslationKey["PROFILE_LINKS_LOG_OUT"] = "PROFILE_LINKS_LOG_OUT";
    TranslationKey["LOGGED_OUT_SIGN_IN"] = "LOGGED_OUT_SIGN_IN";
    TranslationKey["COUNTRY_SELECTOR_LABEL"] = "COUNTRY_SELECTOR_LABEL";
    TranslationKey["STORE_PICKER_US"] = "STORE_PICKER_US";
    TranslationKey["STORE_PICKER_DE"] = "STORE_PICKER_DE";
    TranslationKey["STORE_PICKER_AT"] = "STORE_PICKER_AT";
    TranslationKey["STORE_PICKER_NL"] = "STORE_PICKER_NL";
    TranslationKey["STORE_PICKER_ES"] = "STORE_PICKER_ES";
    TranslationKey["STORE_PICKER_B2B_US"] = "STORE_PICKER_B2B_US";
    TranslationKey["STORE_PICKER_B2B_DE"] = "STORE_PICKER_B2B_DE";
    TranslationKey["STORE_PICKER_B2B_AT"] = "STORE_PICKER_B2B_AT";
    TranslationKey["STORE_PICKER_B2B_NL"] = "STORE_PICKER_B2B_NL";
    TranslationKey["STORE_PICKER_B2B_ES"] = "STORE_PICKER_B2B_ES";
    TranslationKey["LANGUAGE_SELECTOR_LABEL"] = "LANGUAGE_SELECTOR_LABEL";
    TranslationKey["LANGUAGE_PICKER_EN"] = "LANGUAGE_PICKER_EN";
    TranslationKey["LANGUAGE_PICKER_DE"] = "LANGUAGE_PICKER_DE";
    TranslationKey["LANGUAGE_PICKER_NL"] = "LANGUAGE_PICKER_NL";
    TranslationKey["LANGUAGE_PICKER_ES"] = "LANGUAGE_PICKER_ES";
    TranslationKey["SIGN_IN"] = "SIGN_IN";
    TranslationKey["SIGN_UP"] = "SIGN_UP";
    TranslationKey["TIPS_LINKS_HIW_TEXT"] = "TIPS_LINKS_HIW_TEXT";
    TranslationKey["OFFERINGS_LINKS_STUDENT_BEANS_TEXT"] = "OFFERINGS_LINKS_STUDENT_BEANS_TEXT";
    TranslationKey["OFFERINGS_LINKS_TOP_PRODUCTS_TEXT"] = "OFFERINGS_LINKS_TOP_PRODUCTS_TEXT";
    TranslationKey["OFFERINGS_LINKS_DEALS_TEXT"] = "OFFERINGS_LINKS_DEALS_TEXT";
    TranslationKey["OFFERINGS_LINKS_REQUEST_OFFER_TEXT"] = "OFFERINGS_LINKS_REQUEST_OFFER_TEXT";
    TranslationKey["OFFERINGS_LINKS_B2C_TEXT"] = "OFFERINGS_LINKS_B2C_TEXT";
    TranslationKey["MIX_LANDING_NAV_TITLE"] = "MIX_LANDING_NAV_TITLE";
    TranslationKey["OFFERINGS_LINKS_B2B_TEXT"] = "OFFERINGS_LINKS_B2B_TEXT";
    TranslationKey["ACCOUNT_MENU_YOUR_PROFILE"] = "ACCOUNT_MENU_YOUR_PROFILE";
    TranslationKey["TASKBAR_FOR_YOU"] = "TASKBAR_FOR_YOU";
    TranslationKey["TASKBAR_YOUR_TECH"] = "TASKBAR_YOUR_TECH";
    TranslationKey["PROFILE_LINKS_REFERRALS_TEXT"] = "PROFILE_LINKS_REFERRALS_TEXT";
    TranslationKey["TASKBAR_CARD"] = "TASKBAR_CARD";
    TranslationKey["COMPANY_LINKS_FAQ_TEXT"] = "COMPANY_LINKS_FAQ_TEXT";
    TranslationKey["CONTACT_BUTTON_TEXT"] = "CONTACT_BUTTON_TEXT";
    TranslationKey["ACCOUNT_MENU_WISHLIST_TITLE"] = "ACCOUNT_MENU_WISHLIST_TITLE";
    TranslationKey["ACCOUNT_MENU_WISHLIST_DESCRIPTION"] = "ACCOUNT_MENU_WISHLIST_DESCRIPTION";
    TranslationKey["ACCOUNT_MENU_YOUR_PAYMENTS_TITLE"] = "ACCOUNT_MENU_YOUR_PAYMENTS_TITLE";
    TranslationKey["ACCOUNT_MENU_YOUR_PAYMENTS_DESCRIPTION"] = "ACCOUNT_MENU_YOUR_PAYMENTS_DESCRIPTION";
    TranslationKey["ACCOUNT_MENU_REFERRALS_TITLE"] = "ACCOUNT_MENU_REFERRALS_TITLE";
    TranslationKey["ACCOUNT_MENU_REFERRALS_DESCRIPTION"] = "ACCOUNT_MENU_REFERRALS_DESCRIPTION";
    TranslationKey["ACCOUNT_MENU_CONTACT_US_TITLE"] = "ACCOUNT_MENU_CONTACT_US_TITLE";
    TranslationKey["ACCOUNT_MENU_CONTACT_US_DESCRIPTION"] = "ACCOUNT_MENU_CONTACT_US_DESCRIPTION";
    TranslationKey["RESUME_REGISTRATION_HINT_URL_TEXT"] = "RESUME_REGISTRATION_HINT_URL_TEXT";
    TranslationKey["RESUME_REGISTRATION_HINT_TEXT"] = "RESUME_REGISTRATION_HINT_TEXT";
    TranslationKey["TASKBAR_DASHBOARD"] = "TASKBAR_DASHBOARD";
    TranslationKey["SERVICE_TEXT_GROVER_CARE"] = "SERVICE_TEXT_GROVER_CARE";
    TranslationKey["ACCOUNT_MENU_SETTING"] = "ACCOUNT_MENU_SETTING";
    TranslationKey["HELP_CENTER_BUTTON_TEXT"] = "HELP_CENTER_BUTTON_TEXT";
})(TranslationKey || (exports.TranslationKey = TranslationKey = {}));
//# sourceMappingURL=translation.keys.js.map